export const isPrerender = process.env.PRERENDER;
export const basename = process.env.BASE_PATH;
export const EXAMPLE_DIMENSIONS = process.env.EXAMPLE_DIMENSIONS;
export const showDeviceFrame = process.env.SHOW_DEVICE_FRAME;
export const prerenderExample = process.env.PRERENDER_EXAMPLE;
export const audienceDefault = process.env.AUDIENCE_TOGGLE;
export const componentsEntryName = process.env.COMPONENTS_ENTRY_NAME;
export const compilerOptions = process.env.COMPILER_OPTIONS;
export const a11yConfig = process.env.A11Y_CONFIG;
//# sourceMappingURL=config.js.map